import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cep-autofill"
// When a Brazilian CEP (postal code) is entered, fetches address data from
// ViaCEP (free Correios API) and auto-fills street, city, and neighborhood.
//
// Usage:
//   <div data-controller="cep-autofill">
//     <input data-cep-autofill-target="cep" data-action="blur->cep-autofill#lookup">
//     <input data-cep-autofill-target="address">
//     <input data-cep-autofill-target="neighborhood">
//     <select data-cep-autofill-target="city">
//   </div>
export default class extends Controller {
  static targets = ["cep", "address", "neighborhood", "city"]

  lookup() {
    const raw = this.cepTarget.value.replace(/\D/g, "")
    if (raw.length !== 8) return

    fetch(`https://viacep.com.br/ws/${raw}/json/`)
      .then(r => r.json())
      .then(data => {
        if (data.erro) return

        // Fill address (logradouro)
        if (this.hasAddressTarget && data.logradouro) {
          this.addressTarget.value = data.logradouro
        }

        // Fill neighborhood (bairro)
        if (this.hasNeighborhoodTarget && data.bairro) {
          this.neighborhoodTarget.value = data.bairro
        }

        // Fill city — try to match in a <select> dropdown first, fall back to text input
        if (this.hasCityTarget && data.localidade) {
          const cityEl = this.cityTarget
          if (cityEl.tagName === "SELECT") {
            // Try to find an option matching the city name
            const options = Array.from(cityEl.options)
            const match = options.find(o =>
              o.text.trim().toLowerCase() === data.localidade.trim().toLowerCase()
            )
            if (match) {
              cityEl.value = match.value
            }
          } else {
            cityEl.value = data.localidade
          }
        }
      })
      .catch(() => {
        // Silent fail — network error or invalid CEP
      })
  }
}
